/* ==========================================================================
   AiTrillion 购物车兑换积分组件 — 折叠式交互补丁（纯叠加，不改 App 代码）
   - 入口行由 Liquid 服务端渲染（Dawn 重绘抽屉后依然存在）
   - 本脚本只做行为：点入口展开/收起、点别处或 ESC 自动收起、抽屉关闭后复位
   - 只给 App 的容器加/删 class，从不改写 App 注入的 HTML
   ========================================================================== */
(function () {
  'use strict';

  var SEL_WIDGET = '.aaa-loyalty-cartredeem-widget';
  var SEL_TOGGLE = '[data-ait-redeem-toggle]';
  var SEL_DRAWER = 'cart-drawer';
  var CLASS_COLLAPSED = 'ait-redeem-collapsed';
  var CLASS_OPEN = 'ait-redeem-open';
  var FALLBACK_LABEL = 'Redeem reward points';

  function widget() {
    return document.querySelector(SEL_WIDGET);
  }

  function isOpen() {
    var w = widget();
    return !!w && w.classList.contains(CLASS_OPEN);
  }

  function hasContent(w) {
    return !!w && (w.innerHTML || '').replace(/&nbsp;/g, ' ').trim().length > 0;
  }

  /* App 会在容器里先塞一个 <style> 标签（:root{--aiolytthemeColor…}），
     直接读 textContent 会把 CSS 文本读成标题 —— 只从可见文案里取。 */
  var JUNK_SEL = 'style,script,noscript,template,input,select,textarea,button,.visually-hidden,.hidden,#discount-options,.aaa-ly-cart-form';
  function visibleText(node) {
    if (!node) return '';
    var clone = node.cloneNode(true);
    var junk = clone.querySelectorAll ? clone.querySelectorAll(JUNK_SEL) : [];
    for (var i = 0; i < junk.length; i++) junk[i].parentNode.removeChild(junk[i]);
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function looksLikeCode(t) {
    return !t || /^[.:#@]/.test(t) || t.indexOf('{') !== -1 || t.indexOf('--') === 0 || /[a-z-]+\s*:\s*[^ ]+;/i.test(t);
  }

  function labelFromWidget(w) {
    if (!w) return FALLBACK_LABEL;
    var t = visibleText(w.querySelector('.points')) || visibleText(w.querySelector('p')) || visibleText(w);
    if (looksLikeCode(t)) return FALLBACK_LABEL;
    var m = t.match(/^(.{0,110}?[.!?])(\s|$)/);
    t = m ? m[1] : t.slice(0, 110);
    return looksLikeCode(t) ? FALLBACK_LABEL : t;
  }

  function syncToggles() {
    var w = widget();
    var open = isOpen();
    var live = hasContent(w);
    var text = document.querySelector(SEL_TOGGLE + ' .ait-redeem-toggle__text');
    if (text && live) {
      var l = labelFromWidget(w);
      if (l && text.textContent !== l) text.textContent = l;
    }
    var list = document.querySelectorAll(SEL_TOGGLE);
    for (var i = 0; i < list.length; i++) {
      list[i].hidden = !live;
      list[i].setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  function setOpen(open) {
    var w = widget();
    if (!w) return;
    w.classList.toggle(CLASS_OPEN, !!open);
    w.classList.toggle(CLASS_COLLAPSED, !open);
    syncToggles();
  }

  /* 顾客正在兑换的过程中不要抢走界面 */
  function busy() {
    var w = widget();
    if (!w) return false;
    var active = document.activeElement;
    if (active && w.contains(active) && /^(INPUT|SELECT|TEXTAREA)$/.test(active.tagName)) return true;
    var code = w.querySelector('.aaa_last_cart_code');
    if (code && (code.textContent || '').trim()) return true;
    if (w.querySelector('#aio-discount-code')) return true;
    if (w.querySelector('.aaa-sucess-box, .aaa-error-box')) return true;
    var res = w.querySelector('.discount_code_generate_div_result');
    if (res && (res.textContent || '').trim()) return true;
    return false;
  }

  function collapse() {
    if (isOpen() && !busy()) setOpen(false);
  }

  /* ---- 组件本身：点入口展开 / 点别处收起 ------------------------------- */
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest(SEL_TOGGLE)) {
        e.preventDefault();
        setOpen(!isOpen());
        return;
      }
      if (!isOpen()) return;
      if (isAiTrillionLayer(t)) return;
      var w = widget();
      if (w && (t === w || w.contains(t))) return;
      collapse();
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') collapse();
  });

  /* ---- AiTrillion 全屏弹层：点空白 / ESC 关闭兜底 ----------------------- */
  function isAiTrillionLayer(el) {
    return !!(el.closest('.aaa-loyalty-overlay') || el.closest('.aio_alert_overlay') || el.closest('.aaa-rl-overlay'));
  }

  function hideLoyaltyPopup() {
    try {
      if (typeof window.aaa_loyalty_hide_popup === 'function') {
        window.aaa_loyalty_hide_popup();
        return;
      }
    } catch (err) {}
    var layers = document.querySelectorAll('.aaa-loyalty-overlay, .aaa-rl-overlay');
    for (var i = 0; i < layers.length; i++) {
      layers[i].style.visibility = 'hidden';
      layers[i].style.opacity = '0';
    }
    var pops = document.querySelectorAll('.aaa-loyalty-popup');
    for (var j = 0; j < pops.length; j++) pops[j].classList.remove('show_loyalty_popup', 'zoomanim');
    document.body.style.overflowY = 'visible';
  }

  function hideAlert() {
    var o = document.querySelectorAll('.aio_alert_overlay');
    for (var i = 0; i < o.length; i++) {
      o[i].style.visibility = 'hidden';
      o[i].style.opacity = '0';
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var overlay = t.closest('.aaa-loyalty-overlay');
      if (overlay && !t.closest('.aaa-loyalty-popup')) {
        hideLoyaltyPopup();
        return;
      }
      var alert = t.closest('.aio_alert_overlay');
      if (alert && !t.closest('.aaa_alert_popup')) hideAlert();
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (document.querySelector('.aaa-loyalty-popup.show_loyalty_popup')) {
      hideLoyaltyPopup();
      return;
    }
    var alert = document.querySelector('.aio_alert_overlay');
    if (alert && getComputedStyle(alert).visibility !== 'hidden') hideAlert();
  });

  /* ---- 抽屉状态：关闭后复位为折叠；重绘后重新同步 ---------------------- */
  function watchDrawer() {
    var drawer = document.querySelector(SEL_DRAWER);
    if (!drawer) return false;
    new MutationObserver(function () {
      if (!drawer.classList.contains('active')) {
        var w = widget();
        if (w) {
          w.classList.remove(CLASS_OPEN);
          w.classList.add(CLASS_COLLAPSED);
        }
        syncToggles();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    return true;
  }

  var pending = null;
  function scheduleSync() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      syncToggles();
      watchDrawer();
    }, 200);
  }

  function boot() {
    syncToggles();
    watchDrawer();
    /* Dawn 会重绘抽屉内容，APP 也会异步注入 —— 轮询 + DOM 变化双重兜底 */
    new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true });
    setInterval(function () {
      syncToggles();
      watchDrawer();
    }, 1000);
    window.__aitRedeemUx = { setOpen: setOpen, state: function () { return { open: isOpen(), content: hasContent(widget()) }; } };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
